import React from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from 'query-string'

import Listx from "../../../../../../components/listx";
import * as page from "../../../../../../store/ducks/page.duck";

class List extends Listx {

  constructor(props) {
    super(props);

    this.currentPage = queryString.parse(this.props.location.search);

    this.headings = [
      { id: '#', label: '#' },
      { id: 'name', label: 'Title' },
      { id: 'description', label: 'Description', sort : false },
      { id: 'level', label: 'Level' },
    ];

    if(props.title){
      this.title = props.title;
    }
  }


  renderRowData(data){
    return [
      this.renderCell(data.title),
      this.renderCell(data.description),
      this.renderCell(data.level),
      this.renderCell(
        <>
        {this.defaultActions(data.id)}
        </>
      , null, true),
    ];
  }

}

// Set default props
List.defaultProps = {
  canUpdate: true,
  canDelete: true,
  canCreate : true,
  CustomFilter : null,
  backLink : null,
};

const mapStateToProps = (state) => {
  return {
    module: state.page.module,
    redraw: state.page.reload,
  }
}

export default withRouter(connect(
  mapStateToProps,
  page.actions
)(List));